import { useContext } from 'react'

import { RulesContext } from '../RulesContext'
import type { RulesPayload } from '../types'

/**
 *
 * `useValidateRules` is a custom hook that provides access to the `RulesPayload` from the `RulesContext`.
 * It uses the `useContext` hook from React to access the context value.
 *
 * The hook returns the `RulesPayload` context value.
 *
 * @returns {RulesPayload} The `RulesPayload` context value.
 *
 */
export function useValidateRules(): RulesPayload {
  return useContext(RulesContext)
}
